export default "__VITE_ASSET__xscMcvW5__"